import * as countries from "country-flag-icons/react/3x2";
import ISO6391 from "iso-639-1";

export interface LanguageOption {
  code: string;
  name: string;
  nativeName: string;
  flag: React.ComponentType<any>;
  countryCode: string;
}

const languageToCountry: Record<string, string> = {
  en: "US",
  es: "ES",
  it: "IT",
  el: "GR",
};

export const getLanguageOptions = (): LanguageOption[] => {
  const supportedLanguages = ["en", "es", "it", "el"];

  return supportedLanguages.map(code => {
    const countryCode = languageToCountry[code];
    const FlagComponent = countries[countryCode as keyof typeof countries];

    return {
      code,
      name: ISO6391.getName(code),
      nativeName: ISO6391.getNativeName(code),
      flag: FlagComponent,
      countryCode
    };
  });
};
